import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, onMounted, ref, watch } from 'vue'
import { useStore } from '@/store'
import { useRoute } from 'vue-router/composables'
import { Dialog, Toast } from '@sg/sg-vant'
import {
  sendVerifyCode,
  nonStandard
} from '@/http/service/goods'

import utils from '@/utils/utils.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'appointment-popup',
  props: {
  showAppointmentPopup: {
    type: Boolean,
    default: false
  },
  products: {
    type: Object,
    required: false
  },
  storeInfo: {
    type: Object || null,
    required: false
  }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;

const lazyChangeGeographicLocation = () => import('@/components/addressList/change-geographic-location.vue')

const Store = useStore()
const Route = useRoute()



const showAppointmentPopup = computed({
  get() {
    return props.showAppointmentPopup
  },
  set(val) {
    return emit('close')
  }
})


const location = computed(() => {
  return Store.getters['getlocationInfo']
})
const phoneNumber = ref('')

watch(showAppointmentPopup, (nv) => {
  if(nv) phoneNumber.value = (utils.strJSONParse(localStorage?.getItem('userInfo'), {}))?.phone || Store.state?.userInfo?.phone || ''
  resetData()
})

const formData = reactive({
  phoneNumber: phoneNumber.value || '',
  verifiyCode: '',


  provinceCode : location.value.provinceCode || '',
  cityCode : location.value.cityCode || '',
  areaCode : location.value.districtCode || '',
  streetCode : location.value.townshipCode || '',
  provinceName : location.value.province || '',
  cityName : location.value.city || '',
  areaName : location.value.district || '',
  streetName: location.value.township || '',
  address: location.value.region || '',
})

const resetData = () => {
  formData.phoneNumber = phoneNumber.value || ''
  formData.verifiyCode = ''
  formData.provinceCode = location.value.provinceCode || ''
  formData.cityCode = location.value.cityCode || ''
  formData.areaCode = location.value.districtCode || ''
  formData.streetCode = location.value.townshipCode || ''
  formData.provinceName = location.value.province || ''
  formData.cityName = location.value.city || ''
  formData.areaName = location.value.district || ''
  formData.streetName = location.value.township || ''
  formData.address = location.value.region || ''


  if (codeData.intervalId) {
    clearInterval(codeData.intervalId)
    codeData.intervalId = null
    codeData.secondValue = 60
  }

  showAddressPopup.value = false
}


const codeData = reactive({
  secondValue: 60,
  intervalId: null,
})

const sendVerifiyCode = async () => {
  if (!utils.isPhone(formData.phoneNumber)) {
    Toast('请输出正确的手机号')
    return
  }

  Toast.loading({
    message: '加载中...',
    forbidClick: true,
    loadingType: 'spinner',
  })
  const res = await sendVerifyCode({
    customerTel: formData.phoneNumber
  })
  Toast.clear()
  if (res.success) {
    codeData.intervalId = setInterval(() => {
      if (codeData.secondValue > 1) {
        codeData.secondValue--
      } else {
        clearInterval(codeData.intervalId)
        codeData.intervalId = null
        codeData.secondValue = 60
      }
    }, 1000)
  } else {
    Toast(res.message || '请求失败')
  }
}



const showAddressPopup = ref(false)
const handleGeoLocation = (obj) => {
  console.log('handleGeoLocation', obj)
  formData.provinceCode = obj.areaCode?.provinceCode || ''
  formData.cityCode = obj.areaCode?.cityCode || ''
  formData.areaCode = obj.areaCode?.regionCode || ''
  formData.streetCode = obj.areaCode?.streetCode || ''
  formData.provinceName = obj.province || ''
  formData.cityName = obj.city || ''
  formData.areaName = obj.district || ''
  formData.streetName = obj.township || ''
  formData.address = obj.region || ''

  showAddressPopup.value = false
}

const showCodeInput = computed(() => {
  return utils.isPhone(formData.phoneNumber) && phoneNumber.value !== formData.phoneNumber
})

const submit = async () => {
  if (!utils.isPhone(formData.phoneNumber)) {
    Toast('请输出正确的手机号')
    return
  }
  if (showCodeInput.value && formData.verifiyCode.length !== 6) {
    Toast('验证码错误，请重新输入')
    return
  }
  Toast.loading({
    message: '加载中...',
    forbidClick: true,
    loadingType: 'spinner',
  })
  try {
    const res = await nonStandard({
      customerName: formData.phoneNumber,
      customerTel: formData.phoneNumber,
      customerType: Route.query.customerType || '',
      sku: props.products.sku,
      productName: props.products.productName,
      fkSceneCode: Route.query.fkcode || '',
      fcSceneCode: Route.query.sceneCode || '',
      sceneVersion: Route.query.sceneVersion || '',
      storeCode: props.storeInfo?.storeCode || '',
      mdCode: props.storeInfo?.mdCode || '',
      mdGrade: props.storeInfo?.mdGrade || '',
  
      provinceCode: formData.provinceCode,
      cityCode: formData.cityCode,
      areaCode: formData.areaCode,
      streetCode: formData.streetCode,
      provinceName: formData.provinceName,
      cityName: formData.cityName,
      areaName: formData.areaName,
      streetName: formData.streetName,
      address: formData.address,
  
      sourceType: Store.getters['sourceTypeAndCode'].sourceType || '',
      sourceCode: Store.getters['sourceTypeAndCode'].sourceCode || '',
      verificationCode: formData.verifiyCode || ''
    })
    Toast.clear()
    if (res.success) {
      Dialog.confirm({
        title: '温馨提示',
        message: '报名成功，平台客服售后会与您联系',
        confirmButtonText: '我知道了',
        showCancelButton: false,
      }).then(() => {
        showAppointmentPopup.value = false
      }).catch(() => {})
    } else {
      Toast(res.message || '请求失败')
    }
  } catch (err) {
    Toast('请求失败')
  }
}

return { __sfc: true,lazyChangeGeographicLocation, Store, Route, emit, props, showAppointmentPopup, location, phoneNumber, formData, resetData, codeData, sendVerifiyCode, showAddressPopup, handleGeoLocation, showCodeInput, submit }
}

})